import {
	Button,
	Checkbox,
	Divider,
	Grid,
	Paper,
	Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import xlsx from '../images/xlsx.png';
import pdf from '../images/pdf.png';
import WebLogo from '../../../../assets/logos/websitelogo.svg';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { utils, writeFile } from 'xlsx';
import {
	borderColor,
	buttonStyles,
	button_Styles1,
	button_Styles2,
	csvStyle,
	filterSectionStyle,
	grid_Button_Style,
	headerSection,
	icon_Grid_Style,
	pdfStyle,
	textStyling,
	titleWithTextfield,
	headerStyling,
} from './GeneralStyles';
import CircularProgress from '@mui/material/CircularProgress';

import {
	getChargesReport,
	getVisit,
	getPracticeStaff,
	getAlllocations,
	getLocation,
	getPatientList,
	getPatients_reportComponent,
} from '../../../../app/services/api/apiManager';
import PatientReport from '../PatientReport';
import dayjs from 'dayjs';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

// Dispatch Section
// import { useStateValue } from '../../../services/state/State';
// import { actions } from '../../../services/state/Reducer';

const PVS = () => {
	// const [
	// 	{ practice, practicestats, batches, locations, visits, providers },
	// 	dispatch,
	// ] = useStateValue();

	// const showPracticeData = async () => {
	// 	const response = await getPracticeStaff();
	// 	if (response?.status === 200) {
	// 		dispatch({ type: actions.SET_PROVIDERS, payload: response?.data });
	// 	} else dispatch({ type: actions.SET_PROVIDERS, payload: [] });
	// };

	// All Api Data State
	const [allLocations, setAllLocations] = useState([]);
	const [allProviders, setAllProviders] = useState([]);
	// const [allVisits, setAllVisits] = useState([]);
	const [allPatients, setAllPatients] = useState([]);

	// Filter Data
	const [filterationData, setFilterationData] = useState([]);

	// Loader State
	const [isLoading, setIsLoading] = useState(true);
	// Navigate to Page State
	const [currentPage, setCurrentPage] = useState(true);

	// Save All Api Data
	const [apiData, setApiData] = useState([]);

	// Pdf Data State
	const [pdfUrl, setPdfUrl] = useState('');

	const practice_id = localStorage.getItem('practice_id'); // Get Practice Id from local Storage

	// Handle Date Value
	const [dateValue, setDateValue] = useState({
		// fromDate: dayjs().startOf('month'),
		// toDate: dayjs(),
		admDate: '',
		// dischargeDate: dayjs(),
	});

	const handleDateValue = (name, date) => {
		setDateValue({
			...dateValue,
			[name]: date,
		});
	};

	// Handle Select Value
	const [selectValue, setSelectValue] = useState({
		// location: '',
		provider: '',
	});
	const handleSelectValue = (event) => {
		setSelectValue({
			...selectValue,
			[event.target.name]: event.target.value,
		});
		showPatientListData(event.target.value);
	};
	const [selectedLocations, setSelectedLocations] = useState([]); // Location State

	// Reset All Values
	const resetValues = () => {
		setSelectValue({
			// location: '',
			provider: '',
		});
		setSelectedLocations([]);
		setDateValue({
			// fromDate: '',
			// toDate: '',
			admDate: '',
			// dischargeDate: '',
		});

		setFilterationData([]);
	};

	// Function -- Filter Data CSV File
	const getAllValuesCSV = () => {
		const filterationData = allPatients?.filter((item) => {
			const isLocationData =
				selectedLocations.length === 0 ||
				selectedLocations
					.map((locationId) => parseInt(item?.locationid) === locationId)
					.includes(true);

			// const isProviderMatch =
			// 	!selectValue.provider || item?.providerid == selectValue.provider;

			const isAdmissionDate =
				!dateValue.admDate ||
				dayjs(item?.Admission_date).format('MM-DD-YYYY') ==
					dayjs(dateValue.admDate).format('MM-DD-YYYY');

			const activeStatus = item?.Inactive == null || item?.Inactive == false;

			return (
				isAdmissionDate && isLocationData && activeStatus
				// isProviderMatch && isAdmissionDate && isLocationData && activeStatus
			);
		});

		downloadCSV(filterationData);
		setFilterationData(filterationData);
	};

	// Function -- Filter Data PDF File

	const getAllValues = () => {
		const filterationData = allPatients?.filter((item) => {
			// const isLocationMatch =
			// 	!selectValue.location || item?.locationid == selectValue.location;

			const isLocationData =
				selectedLocations.length === 0 ||
				selectedLocations
					.map((locationId) => parseInt(item?.locationid) === locationId)
					.includes(true);

			// const isProviderMatch =
			// 	!selectValue.provider || item?.providerid == selectValue.provider;

			const isAdmissionDate =
				!dateValue.admDate ||
				dayjs(item?.Admission_date).format('MM-DD-YYYY') ==
					dayjs(dateValue.admDate).format('MM-DD-YYYY');

			const activeStatus = item?.Inactive == null || item?.Inactive == false;

			return (
				isLocationData && isAdmissionDate && activeStatus
				// isProviderMatch && isAdmissionDate && isLocationData && activeStatus
			);
		});

		downloadPdf(filterationData);
		setFilterationData(filterationData);
	};

	// Function For Getting Charges Report

	// const getData = async () => {
	// 	try {
	// 		const response = await getChargesReport();
	// 		// console.log(response.data);
	// 		setApiData(response.data); // Set All Api Data
	// 		setIsLoading(false);
	// 	} catch (error) {
	// 		console.log(error);
	// 	}
	// };

	// Define table styles
	const styles = {
		cellPadding: 2,
		fontSize: 10,
		halign: 'left',
		valign: 'middle',
		// fillColor: '#EEEEEE', // Background color of table cells
		// textColor: '#000000', // Text color of table cells
		fontStyle: 'normal', // Font style of table cells
		// overflow: 'ellipsize', // How to handle overflowing content
		lineWidth: 0.1, // Width of table borders
		lineColor: '#000000', // Color of table borders
	};

	// Download PDF File -- All Data
	const downloadAllData = () => {
		// Filter only active patients
		const activeStatus = allPatients?.filter((item) => {
			return item?.Inactive == null || item?.Inactive == false;
		});

		// Create a new PDF document
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const title = 'All Active Patients Report';
		const textWidth =
			(doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;

		// Add the title
		doc.setFont('helvetica', 'bold');
		doc.text(title, xPos, 15);
		doc.setFont('helvetica', 'normal');

		// Get a unique list of locations
		const locations = [
			...new Set(
				activeStatus.map((item) => item.location || 'Unknown Location')
			),
		];

		locations.forEach((location, locIndex) => {
			if (locIndex > 0) doc.addPage(); // Add a new page for each location after the first one

			// Title for each location group
			doc.text(`Location: ${location}`, 14, 30);

			// Filter patients by the current location
			const locationData = activeStatus.filter(
				(item) => (item.location || 'Unknown Location') === location
			);

			// Create table data
			const bodyData = locationData.map((item, index) => [
				index + 1,
				item?.Name == ', ' ? '' : item?.Name,
				dayjs(item?.DOB).format('MM-DD-YYYY'),
				item?.payer,
				item?.provider == ', ' ? '' : item?.provider,
				item?.location == ', ' ? '' : item?.location,
				item?.Inactive == null || item?.Inactive == false
					? 'Active'
					: 'Inactive',
				// item?.Room_No,
				// item?.referring_id,
				item?.referring == ', ' ? '' : item?.referring,
				item?.MRN,
				dayjs(item?.Admission_date).format('MM-DD-YYYY') +
					' - ' +
					(item?.discharge_date != null
						? dayjs(item?.discharge_date).format('MM-DD-YYYY')
						: 'n/a'),
				'',
				'',
				'',
			]);

			// Add the table for the current location
			doc.autoTable({
				startY: 35,
				head: [
					[
						'Serial No.',
						'Patient',
						'DOB',
						'Insurance',
						'Provider',
						'Location',
						'Status',
						// 'Room No.',
						'Referring',
						'MRN #',
						'Admit - Discharge',
						'Gender',
						'Policy No.',
						'Charges (Count)',
					],
				],
				body: bodyData,
				styles: styles,
				headStyles: {
					fillColor: '#CCCCCC', // Background color of header row
					textColor: '#000000', // Text color of header row
					fontStyle: 'bold', // Font style of header row
				},
			});
		});

		// Save the PDF document
		doc.save('Patient Report.pdf');
	};

	// Download CSV File -- All Data
	const downloadAllCSV = () => {
		const activeStatus = allPatients?.filter((item) => {
			return item?.Inactive == null || item?.Inactive == false;
		});
		const columns = [
			[
				// Colmn Fields Name here
				'Patient',
				'DOB',
				'Inssurance',
				'Provider',
				'Location',
				'Status',
				'Room No.',
				'Ref Physician',
				'MRN #',
				'Admit - Discharge',
				'Gender',
				'Policy No.',
				'Charges (Count)',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);
		utils.sheet_add_aoa(worksheet, columns);

		// Assuming apiData is an array of objects
		activeStatus?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.Name == ', ' ? '' : row?.Name,
						dayjs(row?.DOB).format('MM-DD-YYYY'),
						row?.payer,
						row?.provider == ', ' ? '' : row?.provider,
						row?.location == ', ' ? '' : row?.location,
						row?.Inactive == null || row?.Inactive == false
							? 'Active'
							: 'Inactive',
						row?.Room_No,
						row?.referring == ', ' ? '' : row?.referring,
						row?.MRN,
						dayjs(row?.Admission_date).format('MM-DD-YYYY') +
							' - ' +
							(row?.discharge_date != null
								? dayjs(row?.discharge_date).format('MM-DD-YYYY')
								: 'n/a'),
						'',
						'',
						'',
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Patient Report.xlsx');
	};

	// Download Filter Pdf Data
	const downloadPdf = (data) => {
		// Get unique locations
		const uniqueLocations = [...new Set(data.map((item) => item.location))];

		// Pdf Document
		const doc = new jsPDF({ orientation: 'landscape' });
		const pageWidth = doc.internal.pageSize.getWidth();
		const textWidth =
			(doc.getStringUnitWidth('All Active Patients Report') *
				doc.internal.getFontSize()) /
			doc.internal.scaleFactor;
		const xPos = (pageWidth - textWidth) / 2;
		// Set the font to bold
		doc.setFont('helvetica', 'bold');
		doc.text('All Active Patients Report', xPos, 15);
		// Reset the font if you need to add other non-bold text
		doc.setFont('helvetica', 'normal');
		let startY = 20; // Initial startY position

		const addLocationTitle = (title) => {
			doc.text(title, 15, startY + 5);
		};

		const addTable = (data) => {
			doc.autoTable({
				startY: startY + 10,
				head: [
					[
						'Serial No.',
						'Patient Name',
						'DOB',
						'Insurance Name',
						'Provider',
						'Location',
						'Status',
						'Room No.',
						'Ref Physician',
						'MRN#',
						'Admit - Discharge',
						'Gender',
						'Policy No.',
						'Charges (Count)',
					],
				],
				body: data?.map((item, index) => [
					index + 1,
					item?.Name == ', ' ? '' : item?.Name,
					dayjs(item?.DOB).format('MM-DD-YYYY'),
					item?.payer != null ? item?.payer : '',
					item?.provider == ', ' ? '' : item?.provider,
					item?.location == ', ' ? '' : item?.location,
					item?.Inactive == null || item?.Inactive == false
						? 'Active'
						: 'Inactive',
					item?.Room_No,
					item?.referring == ', ' ? '' : item?.referring,
					item?.MRN,
					dayjs(item?.Admission_date).format('MM-DD-YYYY') +
						' - ' +
						(item?.discharge_date != null
							? dayjs(item?.discharge_date).format('MM-DD-YYYY')
							: 'n/a'),
					'',
					'',
					'',
				]),
				styles: styles,
				headStyles: {
					fillColor: '#CCCCCC', // Background color of header row
					textColor: '#000000', // Text color of header row
					fontStyle: 'bold', // Font style of header row
				},
			});
		};

		const addNewPageIfNeeded = (spaceNeeded) => {
			if (spaceNeeded) {
				doc.addPage();
				startY = 20; // Reset startY for the new page
			} else {
				startY += 10; // Add some space between tables if not the first table
			}
		};

		uniqueLocations.forEach((location, index) => {
			const locationData = data.filter((item) => item.location === location);
			const locationTitle = `Location: ${location}`;
			const tableSpaceNeeded = locationData.length * 10 + 40; // 10 for each row + 40 for headers and padding
			const spaceNeeded =
				startY + tableSpaceNeeded > doc.internal.pageSize.getHeight() - 20;

			addNewPageIfNeeded(spaceNeeded && index > 0);
			addLocationTitle(locationTitle);
			addTable(locationData);
			startY = doc.autoTable.previous.finalY + 5;
		});

		doc.save('Patient Report.pdf');
	};

	// Download CSV File -- Filter Data

	const downloadCSV = (data) => {
		const columns = [
			[
				// Colmn Fields Name here
				'Patient',
				'DOB',
				'Insurance',
				'Provider',
				'Location',
				'Status',
				'Room No.',
				'Ref Physician',
				'MRN #',
				'Admit - Discharge',
				'Gender',
				'Policy No.',
				'Charges (Count)',
			],
		];

		var workbook = utils.book_new();
		var worksheet = utils.json_to_sheet([]);

		utils.sheet_add_aoa(worksheet, columns);

		// Assuming apiData is an array of objects
		data?.forEach((row, index) => {
			utils.sheet_add_json(
				worksheet,
				[
					[
						row?.Name == ', ' ? '' : row?.Name,
						dayjs(row?.DOB).format('MM-DD-YYYY'),
						row?.payer,
						row?.provider == ', ' ? '' : row?.provider,
						row?.location == ', ' ? '' : row?.location,
						row?.Inactive == null || row?.Inactive == false
							? 'Active'
							: 'Inactive',
						row?.Room_No,
						row?.referring == ', ' ? '' : row?.referring,
						row?.MRN,
						dayjs(row?.Admission_date).format('MM-DD-YYYY') +
							' - ' +
							(row?.discharge_date != null
								? dayjs(row?.discharge_date).format('MM-DD-YYYY')
								: 'n/a'),
						'',
						'',
						'',
					],
				],
				{ origin: `A${index + 2}`, skipHeader: true }
			);
		});

		utils.book_append_sheet(workbook, worksheet, 'Report');
		writeFile(workbook, 'Patient Report.xlsx');
	};

	// Function -- Download PDF Data Define here

	const handleDownloadPdf = () => {
		if (
			// dateValue.fromDate === '' &&
			// dateValue.toDate === '' &&
			// selectValue.location === '' &&

			selectedLocations.length === 0 &&
			selectValue.provider === '' &&
			dateValue.admDate === ''

			//  && (dateValue.dischargeDate === '' || dateValue.dischargeDate === undefined)
		) {
			downloadAllData();
		} else {
			// searchValuesFilter();
			getAllValues();
		}
	};

	// Function -- Download CSV Data Define here

	const handleDownloadCSV = () => {
		if (
			// dateValue.fromDate === '' &&
			// dateValue.toDate === '' &&
			selectedLocations.length === 0 &&
			selectValue.provider === '' &&
			dateValue.admDate === ''
			// && (dateValue.dischargeDate === '' || dateValue.dischargeDate === undefined)
		) {
			downloadAllCSV(); // All Data
		} else {
			getAllValuesCSV(); // Filter CSV
		}
	};

	// Function For Getting API Locations Data

	const fetchLocations = async () => {
		try {
			const response = await getLocation();
			if (response?.status === 200) {
				setAllLocations(response?.data);
			}
		} catch (error) {
			console.error('Error fetching Locations:', error);
		}
	};

	// Function For Getting API Provider Data

	const getProviders = async () => {
		try {
			const response = await getPracticeStaff();
			if (response?.status === 200) {
				setAllProviders(response?.data);
			}
		} catch (error) {
			console.error('Error fetching Provider:', error);
		}
	};

	// Function For Getting API Visits Data
	// const getVisits = async () => {
	// 	try {
	// 		// const response = await getChargesReport();
	// 		const response = await getVisit();
	// 		if (response?.status === 200) {
	// 			setAllVisits(response?.data);
	// 		}
	// 	} catch (error) {
	// 		console.error('Error fetching Visits:', error);
	// 	}
	// };

	// Function For Getting API Patient Data
	const showPatientListData = async (selectValue) => {
		try {
			// const response = await getChargesReport();

			const response = await getPatients_reportComponent(
				practice_id,
				selectValue.provider
				// selectedLocations.length > 0 && selectedLocations[0].toString()
			);
			if (response?.status === 200) {
				setAllPatients(response?.data);
			}
		} catch (error) {
			console.error('Error fetching Visits:', error);
		}
	};

	// Fetching Api Data

	useEffect(() => {
		// getData();
		// showPracticeData();

		const fetchData = async () => {
			try {
				await fetchLocations();
				await getProviders();
				// await getVisits();
				await showPatientListData(selectValue);

				// Check if all data arrays are not empty
				if (allLocations && allProviders && allPatients) {
					setIsLoading(false); // Stop loader if all data is available
				}
			} catch (error) {
				console.error('Error fetching data:', error);
				setIsLoading(false); // Stop loader in case of error
			}
		};

		fetchData();
	}, [selectValue, selectedLocations]);

	return currentPage ? (
		isLoading ? (
			// Maxchart Logo instead of Loader
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '80vh',
				}}
			>
				<Box
					sx={{
						opacity: 0 /* Initially hide the logo */,
						animation:
							'fadeInOut 2s linear infinite' /* Apply the fade-in and fade-out animation */,
					}}
				>
					<img className="logo" src={WebLogo} alt="Website Logo" />
				</Box>
			</Box>
		) : (
			<Paper
				elevation={5}
				sx={{
					margin: '1rem',
				}}
			>
				<Box
					sx={{
						flexGrow: 1,
						height: {
							xl: '30vh',
							lg: '30vh',
							md: '30vh',
							sm: '40vh',
							xs: '60vh',
						},
					}}
				>
					<Box style={headerStyling} sx={{ padding: '0.5rem' }}>
						<KeyboardBackspaceIcon
							sx={{
								fontSize: '1.5rem',
								color: 'black',
								bgcolor: 'white',
								borderRadius: '1rem',
								cursor: 'pointer',
								'&:hover': {
									bgcolor: 'black',
									color: 'white',
								},
							}}
							onClick={() => {
								setCurrentPage(false);
							}}
						/>
						<Typography style={headerSection}> Patient Report </Typography>
					</Box>
					<Grid
						container
						spacing={3}
						sx={{
							p: '0rem 2rem',
							margin: '2px',
						}}
						// alignItems={'center'}
					>
						{/*<Grid item xl={3} lg={2} md={3} sm={6} xs={12}>
									<Box style={titleWithTextfield}>
										<Typography fontWeight={'bold'} fontSize={'14px'}>
											From Date
										</Typography>
										<FormControl style={borderColor}>
											<LocalizationProvider dateAdapter={AdapterDayjs}>
												<DatePicker
													name="fromDate"
													value={dateValue.fromDate}
													onChange={(event) => {
														handleDateValue('fromDate', event);
													}}
												/>
											</LocalizationProvider>
										</FormControl>
									</Box>
								</Grid>
								<Grid item xl={3} lg={2} md={3} sm={6} xs={12}>
									<Box style={titleWithTextfield}>
										<Typography fontWeight={'bold'} fontSize={'14px'}>
											To Date
										</Typography>
										<FormControl style={borderColor}>
											<LocalizationProvider
												dateAdapter={AdapterDayjs}
												sx={{ width: 300 }}
											>
												<DatePicker
													name="toDate"
													value={dateValue.toDate}
													onChange={(event) => {
														handleDateValue('toDate', event);
													}}
												/>
											</LocalizationProvider>
										</FormControl>
									</Box>
												</Grid>*/}
						<Grid item xl={3} lg={2} md={3} sm={6} xs={12}>
							<Box style={titleWithTextfield}>
								<Typography fontWeight={'bold'} fontSize={'14px'}>
									Location
								</Typography>

								{/*<FormControl style={borderColor} size="small">
									<InputLabel id="demo-simple-select-label">
										Location
									</InputLabel>
									<Select
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										multiple
										value={locationDropDown?.location}
										label="Location"
										name="location"
										onChange={(event) => handleSelectValueLocation(event)}
										renderValue={(selected) => selected.join(', ')}
										MenuProps={{
											PaperProps: {
												style: {
													overflowX: 'auto',
													maxHeight: '300px',
													width: '160px',
													overflowY: 'auto',
													overflowX: 'auto',
													scrollbarWidth: 'thin',
													scrollbarColor: 'dark',
													msOverflowStyle: 'none',
													WebkitOverflowScrolling: 'touch',
												},
											},
										}}
									>
										<MenuItem value={''}>Clear Filter</MenuItem>
											{allLocations?.map((items, index) => {
												return (
													<MenuItem value={items?.Name} key={index}>
														<Checkbox
															checked={
																locationDropDown.location.indexOf(items?.id) > -1
															}
														/>
														{items?.Name}
													</MenuItem>
												);
											})}
									</Select>
										</FormControl>*/}
								<FormControl style={borderColor} size="small">
									<InputLabel id="location-label">Location</InputLabel>
									<Select
										labelId="location-label"
										id="location"
										label="Location"
										multiple
										value={selectedLocations}
										onChange={(event) => {
											setSelectedLocations(event.target.value);
											showPatientListData(event.target.value);
										}}
										// renderValue={(selected) => {
										// 	const selectedNames = selected.map((id) => {
										// 		const location = allLocations.find(
										// 			(loc) => loc.id === id
										// 		);
										// 		return location ? location.Name : '';
										// 	});
										// 	return selectedNames.join(', ');
										// }}
										renderValue={(selected) => {
											const selectedNames = selected
												.map((id) => {
													const location = allLocations.find(
														(loc) => loc?.id === id
													);
													return location ? location?.Name : '';
												})
												.filter((name) => name); // Filters out any empty strings

											// If only one location is selected, display its name
											if (selectedNames?.length === 1) {
												return selectedNames[0];
											}
											// If more than one location is selected, display "1 + more"
											else if (selectedNames?.length > 1) {
												return `${selectedNames[0]} + ${selectedNames.length - 1} more`;
											}
											// If no location is selected, return an empty string
											else {
												return '';
											}
										}}
										MenuProps={{
											PaperProps: {
												style: {
													maxHeight: '300px',
													width: '130px',
													overflowY: 'auto',
													scrollbarWidth: 'thin',
													scrollbarColor: 'dark',
													msOverflowStyle: 'none',
													WebkitOverflowScrolling: 'touch',
												},
											},
										}}
									>
										{allLocations.map((location) => (
											<MenuItem key={location.id} value={location.id}>
												<Checkbox
													checked={selectedLocations.includes(location.id)}
												/>
												{location.Name}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Box>
						</Grid>
						<Grid item xl={3} lg={2} md={3} sm={6} xs={12}>
							<Box style={titleWithTextfield}>
								<Typography fontWeight={'bold'} fontSize={'14px'}>
									Adm Date
								</Typography>
								<FormControl style={borderColor}>
									<LocalizationProvider dateAdapter={AdapterDayjs}>
										<DatePicker
											name="admDate"
											value={dateValue.admDate}
											slotProps={{ textField: { size: 'small' } }}
											// disableFuture={true}
											onChange={(event) => {
												handleDateValue('admDate', event);
											}}
										/>
									</LocalizationProvider>
								</FormControl>
							</Box>
						</Grid>
						{/*<Grid item xl={3} lg={2} md={3} sm={6} xs={12}>
									<Box style={titleWithTextfield}>
										<Typography fontWeight={'bold'} fontSize={'14px'}>
											Discharge Date
										</Typography>
										<FormControl style={borderColor}>
											<LocalizationProvider
												dateAdapter={AdapterDayjs}
												sx={{ width: 300 }}
											>
												<DatePicker
													name="dischargeDate"
													value={dateValue.dischargeDate}
													onChange={(event) => {
														handleDateValue('dischargeDate', event);
													}}
												/>
											</LocalizationProvider>
										</FormControl>
									</Box>
												</Grid>*/}
						<Grid item xl={3} lg={2} md={3} sm={6} xs={12}>
							<Box style={titleWithTextfield}>
								<Typography fontWeight={'bold'} fontSize={'14px'}>
									Provider
								</Typography>
								<FormControl style={borderColor} size="small">
									<InputLabel id="demo-simple-select-label">
										Provider
									</InputLabel>
									<Select
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										label="Provider"
										name="provider"
										value={selectValue.provider}
										onChange={(event) => handleSelectValue(event)}
										MenuProps={{
											PaperProps: {
												style: {
													maxHeight: '300px',
													width: '160px',
													overflowY: 'auto',
													scrollbarWidth: 'thin',
													scrollbarColor: 'dark',
													msOverflowStyle: 'none',
													WebkitOverflowScrolling: 'touch',
												},
											},
										}}
									>
										<MenuItem value={''}> Clear Filter </MenuItem>
										{allProviders?.map((item, index) => {
											return (
												<MenuItem key={index} value={item?.id}>
													{item?.Fname + ' ' + item?.Lname}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</Box>
						</Grid>
						<Grid item md={3} lg={2} style={grid_Button_Style}>
							<Box
								sx={{
									display: 'flex',
								}}
								// style={buttonStyles}
							>
								{/* <Button
								variant="contained"
								style={button_Styles1}
								onClick={() => getAllValues()}
							>
								{' '}
								Search{' '}
										</Button> */}
								<Button
									variant="contained"
									sx={{
										padding: '0.5rem 1.5rem',
										textTransform: 'capitalize',
										letterSpacing: '0.1rem',
										backgroundColor: '#ED2828',
									}}
									// style={button_Styles2}
									disabled={
										selectedLocations.length != 0 ||
										dateValue.fromDate ||
										dateValue.toDate ||
										dateValue.admDate ||
										dateValue.dischargeDate ||
										selectValue.location ||
										selectValue.provider
											? false
											: true
									}
									onClick={() => {
										resetValues();
									}}
								>
									{' '}
									Reset{' '}
								</Button>
							</Box>
							<Box
								sx={{
									display: 'flex',
									gap: '1rem',
								}}
							>
								<Box
									component={'img'}
									src={xlsx}
									style={csvStyle}
									onClick={() => {
										// downloadCSV();
										handleDownloadCSV();
									}}
								></Box>

								<Box
									component={'img'}
									src={pdf}
									style={pdfStyle}
									onClick={() => {
										// Download Pdf Data
										// downloadPdf();
										handleDownloadPdf();
									}}
								></Box>
							</Box>
						</Grid>
					</Grid>
				</Box>
				<Divider />
				<Box
					sx={{
						height: {
							xl: '55vh',
							lg: '55vh',
							md: '45vh',
							sm: '30vh',
							xs: '15vh',
						},
						// '55vh',
						alignItems: 'center',
						display: 'flex',
					}}
					// style={filterSectionStyle}
				>
					<Grid container>
						<Grid item xs={12}>
							{filterationData?.length > 0 ? null : (
								<Typography
									variant="body1"
									style={textStyling}
									sx={{
										fontSize: {
											xl: '20px',
											lg: '20px',
											md: '16px',
											sm: '12px',
											xs: '12px',
										},
									}}
									disabled
								>
									Please apply filter to get reports
								</Typography>
							)}
							{/*<Typography style={textStyling}>
							Please apply filter to get reports
							</Typography>*/}
						</Grid>
					</Grid>
				</Box>

				{pdfUrl ? (
					<div style={{ marginTop: '20px' }}>
						<iframe src={pdfUrl} width="100%" height="600px" title="PDF" />
					</div>
				) : (
					''
				)}
			</Paper>
		)
	) : (
		<PatientReport />
	);
};

export default PVS;
